export default __webpack_public_path__ + "static/media/survey4.72e4cf85.svg";